import styled from 'styled-components';
import TextField from 'components/Core/TextField';

const Container = styled.div`
  margin-bottom: 60px;

  h6 {
    margin: 0 30px 0 0;
  }

  .ant-select,
  .job-posts-filters--filter-container .ant-select .ant-select-selector {
    width: 100% !important;
  }

  .job-posts-filters--title {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  @media (max-width: 992px) {
    h6 {
      text-align: center;
    }
  }

  @media (max-width: 776px) {
    h6 {
      width: 100%;
      margin: 20px 0 20px 0;
      text-align: center;
    }
  }

  @media (max-width: 576px) {
    .job-posts-filters--filter-container .ant-select .ant-select-selector {
      margin-bottom: 10px;
    }
  }
`;

const StyledTextField = styled(TextField)`
  p {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .ant-input-suffix {
    position: absolute;
    right: 12px;
    bottom: 0;
    top: 0;

    img {
      margin-top: -2px;
      width: 17px;
      height: 17px;
    }
  }

  .ant-input-affix-wrapper.text-field-input {
    height: 64px !important;
    padding: 4px 18px;

    input {
      font-family: var(--font-family);
      color: var(--neutral-5);
      font-size: 18px;
      font-weight: 500;
      opacity: 1;
    }

    input::placeholder {
      font-family: var(--font-family);
      color: var(--neutral-4);
      font-size: 20px;
      font-weight: 500;
      opacity: 1;
    }
  }
`;

export { Container, StyledTextField };
